import AsyncStorage from '@react-native-community/async-storage';
import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl } from './index';

const dispatchRequestRegistation = userData => ({
    type: ActionTypes.REQUEST_REGISTATION,
    userData
})

const dispatchResponseRegistation = res => ({
    type: ActionTypes.REGISTATION_STATUS,
    res
})

const dispatchErrorRegistation = (err) => ({
    type: ActionTypes.ERROR_REGISTATION,
    err
})

export const dispatchClearRegistation = () => ({
    type: ActionTypes.CLEAR_REGISTATION_INFO
})


export function registation(userData) {

    const {userName, firstName, lastName, email, phone} = userData;

    const data = {
        username:userName,
        first_name: firstName,
        last_name: lastName,
        // password: 'password123',
        email,
        phone
    }

    return dispatch => {
        dispatch(dispatchRequestRegistation(userData));

        axios.post(`${baseUrl}/api/register`, data)
            .then(({data}) => {
                dispatch(dispatchResponseRegistation(data));
            })
            .catch(e =>{
                dispatch(dispatchErrorRegistation(e));
            });
    }
}

